import TextWaveScene from "./three/TextWaveScene";

// Bundle séparé (cf. gulpfile.js / has_text_wave_block) pour ne pas alourdir
// bundle.min.js avec three.js sur les pages qui n'utilisent pas ce bloc.
// Ce point d'entrée initialise aussi les canvas du bloc "Cards" (même
// attribut, sélecteur partagé) : chaque carte peut porter un
// data-text-wave-variant pour recevoir un jeu de paramètres différent et
// obtenir un rendu de vague visuellement distinct sans dupliquer la scène.
const WAVE_VARIANTS = [
	// Vague nette à deux crêtes (peu d'harmoniques superposées)
	{ amp: 0.42, freq: 0.8, turb: 2, spacing: 0.55 },
	// Nuage de poussière diffus (amplitude faible, turbulence élevée)
	{ amp: 0.18, freq: 1.6, turb: 6, spacing: 0.4, ptBase: 110, sizeMax: 1.6 },
	// Houle plus ample et plus rapide
	{ amp: 0.55, freq: 1.1, turb: 4, speed: 0.3, spacing: 0.5 },
	// Frise chronologique : nuage de poussière vu en plongée (maquette), points fins et diffus
	{ cols: 140, rows: 48, amp: 0.3, freq: 1.6, turb: 9, spacing: 0.55, ptBase: 70, sizeMin: 1.5, sizeMax: 1.2, camH: 18, lookY: 2, aperture: 0.12 },
];

// Le bloc "Texte + vague" (pas les cartes, déjà positionnées par leur propre transform CSS) coupe
// désormais .wave-canvas au bord de .inner (cf. overflow: hidden dans _block-text-wave.scss) : la
// vague par défaut (planY: 0) rend trop haute dans le cadre pour être coupée par
// .wave-separator-bottom, on la redescend donc un peu en desktop, et davantage en mobile où le
// cadre est plus étroit/haut.
const MOBILE_QUERY = window.matchMedia("(max-width: 767.98px)");
const DESKTOP_PLAN_Y = -2;
const MOBILE_PLAN_Y = -5;

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll("[data-text-wave-canvas]").forEach((container) => {
		const variantIndex = parseInt(container.dataset.textWaveVariant, 10);
		const isCard = Number.isInteger(variantIndex);
		const overrides = isCard
			? WAVE_VARIANTS[variantIndex % WAVE_VARIANTS.length]
			: { planY: MOBILE_QUERY.matches ? MOBILE_PLAN_Y : DESKTOP_PLAN_Y };

		const scene = new TextWaveScene(container, overrides);

		// Pas besoin de détruire/recréer toute la scène pour un simple changement de position :
		// on rejoue juste planY sur l'objet points déjà construit au franchissement du breakpoint.
		// Les cartes gardent leurs propres réglages (WAVE_VARIANTS) quel que soit le format.
		if (!isCard) {
			MOBILE_QUERY.addEventListener("change", (e) => {
				scene.points.position.y = e.matches ? MOBILE_PLAN_Y : DESKTOP_PLAN_Y;
			});
		}
	});
});
